import * as models from "app/models/requireme";
import { generatePushID, sum, mapMany, first } from "keautils";
import { onBorrarIncompleta } from "../entrega/logic";

/**Devuelve true o la razon por la cual no se pueden realizar mas entregas */
export function puedeRealizarEntrega(state: models.ViajeAppIniciado, idDireccionCliente: number): true | "noHayGuiasPendientes" {
    const entregas = state.model.EntregasRealizadas.filter(x => x.IdDireccionDestino == idDireccionCliente);

    //Suma las guias entregas y rechazadas
    const cantGuiasRealizadas = sum(entregas.map(x => x.GuiasNoEntregadas.length + x.IdGuiasEntregadas.length));
    const cantGuiasDestino = state.datos.Guias.filter(x => x.IdDireccionClienteDestino == idDireccionCliente).length;

    if (cantGuiasRealizadas >= cantGuiasDestino) return "noHayGuiasPendientes";
    return true;
}

/**Devuelve el nuevo state despues de agregar una nueva entrega realizada */
export function realizarEntrega(state: models.ViajeAppIniciado, idDireccionCliente: number): models.ViajeAppIniciado {

    const clientes = state.datos.Clientes;
    const direcciones = mapMany(clientes, x => x.Direcciones);
    const direccion = first(direcciones, x => x.IdRegistro == idDireccionCliente)!;
    const cliente = first(clientes, x => x.IdRegistro == direccion.IdCliente)!;

    const nuevaEntrega: models.EntregaRealizadaViajeAppModel = {
        Fecha: new Date(),
        ClaveUnica: generatePushID(),
        IdDireccionDestino: idDireccionCliente,
        IdContactoRecibio: null as any,
        DigitosCheque: "",
        Finalizado: false,
        Firma: {
            Segmentos: []
        },
        GuiasNoEntregadas: [],
        IdGuiasEntregadas: [],
        TipoPago: (cliente.DatosCredito.LimiteCredito && cliente.DatosCredito.LimiteCredito > 0) ? models.TipoPagoEntregaDomicilio.Credito : models.TipoPagoEntregaDomicilio.Efectivo,
        SaldoContabilizadoServidor: false,
        NombreContactoRecibio: ""
    };

    const agregarEntregaState: models.ViajeAppIniciado = {
        ...state,
        model: {
            ...state.model,
            EntregasRealizadas: [
                ...state.model.EntregasRealizadas,
                nuevaEntrega
            ]
        }
    };

    return agregarEntregaState;
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/viajeapp/entregas/logic.ts